import config from '../../config';

export default {
  url: `${config.api.baseURL}/modules`,
  options: {
    method: 'post'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/create.js